// Generated by Ktorfit
@file:Suppress("warnings")

package one.healthium.url_provider.`data`.api

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import de.jensklingenberg.ktorfit.annotationsAttributeKey
import de.jensklingenberg.ktorfit.converter.TypeData
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.http.HttpMethod
import io.ktor.http.URLBuilder
import io.ktor.http.decodeURLQueryComponent
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.Suppress
import kotlin.collections.List
import one.healthium.url_provider.`data`.dto.UrlItemDto

@OptIn(InternalKtorfitApi::class)
internal class _UrlProviderApiClientImpl(
  private val _ktorfit: Ktorfit,
) : UrlProviderApiClient {
  private val _helper: KtorfitConverterHelper = KtorfitConverterHelper(_ktorfit)

  override suspend fun getLegalUrls(): List<UrlItemDto> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "legal_product.json")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<List<UrlItemDto>>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }
}

internal class _UrlProviderApiClientProvider : ClassProvider<UrlProviderApiClient> {
  override fun create(_ktorfit: Ktorfit): UrlProviderApiClient = _UrlProviderApiClientImpl(_ktorfit)
}

internal fun Ktorfit.createUrlProviderApiClient(): UrlProviderApiClient = _UrlProviderApiClientImpl(this)
